export const gitCommit = 'cb39c10f'
